import React from 'react';
import { Home, Store, Building2, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { WHATSAPP_LINK } from '../lib/constants';
const services = [{
  title: 'Fumigación Hogar',
  description: 'Eliminamos cucarachas, hormigas, arañas y más. Productos seguros para tu familia y mascotas.',
  icon: Home
}, {
  title: 'Comercios y Gastronomía',
  description: 'Cumplí con las normativas sanitarias. Servicio discreto y certificado.',
  icon: Store
}, {
  title: 'Consorcios y Edificios',
  description: 'Planes de mantenimiento para espacios comunes. Prevención continua.',
  icon: Building2
}];
export function Services() {
  return <section className="bg-mobal-white py-20" id="servicios" data-id="element-250">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-252">
          <h2 className="text-3xl md:text-5xl font-heading font-black text-mobal-black mb-4" data-id="element-253">
            NUESTROS SERVICIOS
          </h2>
          <div className="w-24 h-1 bg-mobal-green mx-auto" data-id="element-254"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-255">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-mobal-dark rounded-lg overflow-hidden border-t-4 border-mobal-green flex flex-col h-full shadow-xl" data-id="element-256">
              <div className="p-8 flex-grow" data-id="element-257">
                <service.icon className="w-12 h-12 text-mobal-green mb-6" data-id="element-258" />
                <h3 className="text-2xl font-heading font-bold text-mobal-white mb-4" data-id="element-259">
                  {service.title}
                </h3>
                <p className="text-gray-400 font-body text-lg leading-relaxed" data-id="element-260">
                  {service.description}
                </p>
              </div>
              <div className="p-6 pt-0 mt-auto" data-id="element-261">
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2 bg-transparent border border-mobal-green text-mobal-green font-bold py-3 px-4 rounded hover:bg-mobal-green hover:text-mobal-black transition-colors min-h-[44px]" data-id="element-262">
                  <MessageCircle className="w-5 h-5" data-id="element-263" />
                  CONSULTAR
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}